import { bool } from 'prop-types';

// Import components
import { Button, PlayerElements as Player } from 'components/elements';

// Import hooks
import { useAppSelector } from 'store/hooks';
import { useNextMaterial } from 'components/utilities';

const PlayerSeriresControllers = ({ isEpisodeAvaiable }) => {
	const { prev, next } = useAppSelector((state) => state.movieDetails.episodes);
	const { fetchNextMaterial } = useNextMaterial();

	return (
		<>
			<Button disabled={!prev} onClick={fetchNextMaterial.bind(null, prev?.uuid)} modifiers={['icon', 'playerIconHover']}>
				<Player.IconPrevious />
			</Button>

			<Button disabled={!next || !isEpisodeAvaiable} onClick={fetchNextMaterial.bind(null, next?.uuid)} modifiers={['icon', 'playerIconHover']}>
				<Player.IconNext />
			</Button>
		</>
	);
};

PlayerSeriresControllers.propTypes = {
	isEpisodeAvaiable: bool.isRequired
};

export default PlayerSeriresControllers;
